<template>
  <div class="dialogWrapper">
    <div class="dialog">
      <p v-html="$t('dialog.description')" class="description" />
      <div class="wrapper">
        <CustomButton
          :isSingle="false"
          :buttonType="'accent'"
          :customButtonTxt="$t('dialog.cancel')"
          @submit="cancelDialog"
        />
        <CustomButton
          :isSingle="false"
          :buttonType="'primary'"
          :customButtonTxt="$t('dialog.open')"
          @submit="mobileAuthorization"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "MobileDialog",
  components: {
    CustomButton,
  },
  methods: {
    cancelDialog() {
      this.$emit("cancelDialog");
    },
    mobileAuthorization() {
      this.$emit("mobileAuthorization");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.dialogWrapper
  position: fixed
  left: 0
  top: 0
  +size(100%)
  +flex(center, center)
  z-index: 1000
  background-color: rgba(33, 33, 33, 0.5)
  padding: 0 25px
  .dialog
    width: 100%
    border-radius: 10px
    padding: 20px
    background-color: $gs1
    .wrapper
      +flex(space-between, center, row)
</style>
